import React from 'react';

interface InputProps {
  id?: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  autoFocus?: boolean;
  onChange?: (value: string) => void;
  onFocus?: () => void;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { id, name, value, defaultValue, isDisabled = false, isReadOnly = false, autoFocus = false, onChange, onFocus },
    ref,
  ) => (
    <input
      ref={ref}
      type="text"
      className="input"
      id={id}
      name={name}
      value={value}
      defaultValue={defaultValue}
      disabled={isDisabled}
      readOnly={isReadOnly}
      autoFocus={autoFocus}
      onChange={onChange ? e => onChange(e.target.value) : undefined}
      onFocus={onFocus}
    />
  ),
);
